export default {
    methods: {
        /**
         * @param {Object} rule
         * @param {*} value
         * @param {Function} callback
         */
        fieldExternalValidator({field}, value, callback) {
            const errors = _.map(
                _.get(this.errors, field, []), error => new Error(error)
            );
            _.unset(this.errors, field);

            callback(errors);
        },
    }
}
